import React from "react";
import "../../../../../styles/ComponentsStyles/Setting/Preference/NotificationSettings/NotificationToggleButtonListItem.style.css"
const NotificationToggleButtonListItem = ({ title }) => {
  return (
    <div
      className="w-full flex-row align-center justify-between pb-1 NotificationToggleButtonListItem"
      style={{ borderBottom: "2px solid var(--grayBorder)" }}
    >
      <span className="poppins t-13 poppins color-textColor">{title}</span>
      <div className="toggleBtn">
        <input type="checkbox" name="" id="" />
      </div>
    </div>
  );
};

export default NotificationToggleButtonListItem;
